((app) => {
    app.config(["$stateProvider", ($stateProvider) => {
        $stateProvider.state("Root.Policies.List", {
            url: "/List",
            component: "policyList"
        });
    }]);

    app.component("policyList", {
        templateUrl: "/App/States/Policies/List/list.html",
        controller: _listCtrl
    });

    _listCtrl.$inject = ["$scope", "$state", "dataFeedApi", "$q", "searchService", "accessTokenService"];
    function _listCtrl($scope, $state, dataFeedApi, $q, searchService, accessTokenService) {
        let $ctrl = this;
        $ctrl.ui = {};

        $ctrl.passFilters = () => {
            searchService.setFilters($ctrl.filters.carrier, $ctrl.filters.product, $ctrl.filters.productType);
        };

        $scope.$on("searching", () => {
            $ctrl.ui.loading = true;
            $ctrl.filters.search = searchService.getTerm();
            $ctrl.getPolicies().then($ctrl.setPolicies);
        });

        $ctrl.filters = {
            search: searchService.getTerm(),
            carrier: searchService.getFilters()[0],
            product: searchService.getFilters()[1],
            productType: searchService.getFilters()[2]
        };

        $ctrl.clearSearch = () => {
            searchService.reset();
        };

        $ctrl.updateTags = () => {
            $ctrl.tags = {
                search: $ctrl.filters.search,
                carrier: $ctrl.filters.carrier,
                product: $ctrl.filters.product,
                productType: $ctrl.filters.productType
            };
            if ($ctrl.tags.productType !== null) {
                $ctrl.tags.productType = $ctrl.tags.productType.replace(/([A-Z])/g, ' $1').trim();
            }
            searchService.setFilters($ctrl.filters.carrier, $ctrl.filters.product, $ctrl.filters.productType);
        };
        $ctrl.updateTags();

        $ctrl.clearAll = () => {
            $ctrl.filters.search = null;
            $ctrl.filters.carrier = null;
            $ctrl.filters.product = null;
            $ctrl.filters.productType = null;
            searchService.reset();
        };
        
        function getCarrierNames() {
            return dataFeedApi.getAllCarrierNames($ctrl.filters.search, $ctrl.filters.product, $ctrl.filters.productType).then(function (names) {
                $ctrl.carrierNames = names;
            });
        }

        function getProductNames() {
            return dataFeedApi.getAllProductNames($ctrl.filters.search, $ctrl.filters.carrier, $ctrl.filters.productType).then(function (names) {
                $ctrl.productNames = names;
            });
        }

        function getProductTypes() {
            return dataFeedApi.getAllProductTypes($ctrl.filters.search, $ctrl.filters.carrier, $ctrl.filters.product).then(function (types) {
                $ctrl.productTypes = types;
            });
        }

        $ctrl.$onInit = () => {
            if (accessTokenService.getAccessToken()) {
                $ctrl.hasAccess = true;
            } else {
                accessTokenService.registerListener(() => {
                    $ctrl.hasAccess = true;
                });
            }

            if ($ctrl.hasAccess) {
                $ctrl.ui.loading = true;
                var promises = [];
                promises.push(getCarrierNames());
                promises.push(getProductNames());
                promises.push(getProductTypes());
                $q.all(promises).then(function () {
                    $ctrl.loadData();
                });
            }
        };

        $ctrl.columns = [
            { name: "Policy #", selector: "PolicyNumber" },
            { name: "Clients", selector: "Clients" },
            { name: "Agents", selector: "Agents" },
            { name: "Carrier", selector: "Carrier" },
            { name: "Product", selector: "Product" },
            { name: "Product Type", selector: "ProductType" },
            { name: "Current Value", selector: "CurrentAccountValue" },
            { name: "Received On", selector: "ModifiedOn" }
        ];

        $ctrl.getDetails = (mappedPolicyId) => {
            $state.go("Root.Policies.Detail", { MappedPolicyId: mappedPolicyId, fadeFromRight: true });
        };

        $ctrl.highlight = (column) => {
            $ctrl.highlightedColumn = column.selector;
        };

        $ctrl.setOrder = (column) => {
            $ctrl.selectedColumn = column.selector;
            if ($ctrl.order === column.selector) {
                $ctrl.order = "-" + $ctrl.order;
            } else {
                $ctrl.order = column.selector;
            }
        };

        $ctrl.getPolicies = (nextPage, loaded) => {
            if (loaded !== true) {
                $ctrl.ui.loading = true;
            }
            var promises = [];
            if (loaded !== true) {
                promises.push(getCarrierNames());
                promises.push(getProductNames());
                promises.push(getProductTypes());
            }
            return $q.all(promises).then(function () {
                return dataFeedApi.getPolicies($ctrl.filters.search, $ctrl.filters.carrier, $ctrl.filters.product, $ctrl.filters.productType, nextPage);
            });
        };

        $ctrl.setPolicies = (policies) => {
            $ctrl.updateTags();          
            $ctrl.policies = policies || [];
            $ctrl.policies.NextPage = policies.NextPage || -1;
            $ctrl.ui.loading = false;
        };
        
        $ctrl.loadData = () => {
            if ($state.current.name === "Root.Policies.List") {
                $ctrl.policies = $ctrl.policies || [];
                if ($ctrl.policies.NextPage === -1) {
                    return;
                }
                let promise;
                if ($ctrl.filters.search || $ctrl.filters.carrier || $ctrl.filters.product || $ctrl.filters.productType) {
                    promise = $ctrl.getPolicies($ctrl.policies.NextPage, true);
                } else {
                    promise = dataFeedApi.getLatestPolicies($ctrl.policies.NextPage);
                }
                promise.then((policies) => {
                    $ctrl.policies = $ctrl.policies.concat(policies);
                    $ctrl.policies.NextPage = policies.NextPage || -1;
                    $ctrl.ui.loading = false;
                }).catch((err) => { });
            }        
        };
    }
})(window.app, window.angular);